export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/platform-ring.b0b3432e-6a79b7.png";